import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <main className="flex-grow flex flex-col justify-center">
      <section className="flex flex-col justify-center items-center gap-4">
        <h1 className="text-6xl tracking-tight font-extrabold lg:text-9xl text-center">
          404
        </h1>
        <p className="text-3xl tracking-tight font-bold text-gray-900 text-center">
          Something's missing.
        </p>
        <p className="text-lg font-light text-gray-600 text-center">
          Sorry, we can't find that page.
        </p>
        <Link
          to="/home"
          className="text-white bg-(--dr-dark) hover:bg-(--dr-dark-var) font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          Back to Homepage
        </Link>
      </section>
    </main>
  );
};

export default NotFound;
